import workerUrl from '!!file-loader!./load-worker.js'
import inflateUrl from '!!file-loader!pako/dist/pako_inflate.min.js'
import summary from '../data/compiled/summary.json'

export const assetOrigin =
  'https://doublez-site-bed.oss-cn-shanghai.aliyuncs.com'
const dataOrigin = process.env.NODE_ENV === 'development' ? '' : assetOrigin
const runtimeUrl = `${dataOrigin}/hangzhou/compiled/runtime.json.gz?v=${summary.revision}`
const pointsUrl = `${dataOrigin}/hangzhou/compiled/points.bin.gz?v=${summary.revision}`
const coverageUrl = `${dataOrigin}/hangzhou/compiled/urban.bin.gz?v=${summary.revision}`

let cached
export function loadData(signal) {
  if (cached) return Promise.resolve(cached)
  return new Promise((resolve, reject) => {
    let worker, timer
    const cleanup = () => {
      clearTimeout(timer)
      signal.removeEventListener('abort', abort)
      if (worker) worker.terminate()
    }
    const fail = (error) => {
      cleanup()
      reject(error)
    }
    const abort = () => fail(new DOMException('Aborted', 'AbortError'))
    if (signal.aborted) return abort()
    signal.addEventListener('abort', abort, { once: true })
    try {
      worker = new Worker(workerUrl)
      worker.onmessage = ({ data: result }) => {
        if (result.error) return fail(new Error(result.error))
        const { data, vertices, buckets } = result
        cached = {
          ...data,
          summary,
          initialCoverage: { vertices, buckets },
        }
        cleanup()
        resolve(cached)
      }
      worker.onerror = () => fail(new Error('地图数据未能加载，请重新加载。'))
      timer = setTimeout(
        () => fail(new Error('地图加载超时，请检查网络后重试。')),
        120000
      )
      worker.postMessage({ runtimeUrl, pointsUrl, coverageUrl, inflateUrl })
    } catch (_) {
      fail(new Error('交互地图未能启动，请重新加载或更换浏览器。'))
    }
  })
}
